import React from 'react';

export default ({ color = '#8E95AA', size = 19 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0837 2.85156H5.54199C5.22705 2.85156 4.925 2.97667 4.7023 3.19937C4.4796 3.42207 4.35449 3.72412 4.35449 4.03906V14.9641C4.35449 15.279 4.4796 15.5811 4.7023 15.8038C4.925 16.0265 5.22705 16.1516 5.54199 16.1516H13.4587C13.7736 16.1516 14.0756 16.0265 14.2983 15.8038C14.521 15.5811 14.6462 15.279 14.6462 14.9641V6.3349L11.0837 2.85156Z"
      stroke={color}
      strokeWidth="1.34583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.083 2.85156V6.3349H14.5663"
      stroke={color}
      strokeWidth="1.34583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.72949 9.81641H12.2712M6.72949 12.5872H12.2712"
      stroke={color}
      strokeWidth="1.34583"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
